/**
 * Created by jv on 18/01/2017.
 */
const moment = require("moment");
const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/languagemanager");

module.exports = class Activation
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.fakeKey = utils.UUID();

    this.userKey = options["user-key"];
    this.applicationKey = options["application-key"];
    this.applicationName = options["application-name"];

    this.tokenKey = options.tokenKey;
    this.tokenCode = options.tokenCode;

    this.installation = options.installation;

    this.email = options.email;

    this.current = options.current;
    this.lastUsed = options["last-used"];
    this.stamp = options.stamp;
  };

  set lastUsed(date)
  {
    this._lastUsed = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  };

  get lastUsed()
  {
    return utils.isMomentObject(this._lastUsed) ? this._lastUsed.format("DD-MM-YYYY") : null;
  };

  set stamp(date)
  {
    this._stamp = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  };

  get stamp()
  {
    return utils.isMomentObject(this._stamp) ? this._stamp.format("DD-MM-YYYY") : null;
  };

  get readableInstallation()
  {
    return this.installation === "avi-default-installation" ? LanguageManager.getValueForKey("globals.not_applicable") : this.installation;
  }
};

/*
 get installation()
 {
 return this._installation === "avi-default-installation" ? LanguageManager.getValueForKey("globals.not_applicable") : this._installation;
 }

 set installation(installation)
 {
 this._installation = installation;
 }
 */



// WEBPACK FOOTER //
// ./app/js/models/activation.js